import { formatPct, holdingColor, toNumber } from '../utils/portfolio';
import './PieLegend.css';

/** Colour key for a Donut. Uses the same index-based colours. */
export default function PieLegend({ holdings }) {
  return (
    <ul className="legend">
      {holdings.map((h, i) =>
        toNumber(h.pct) > 0 ? (
          <li key={`${h.ticker || h.label}-${i}`} className="legend__item">
            <span className="legend__dot" style={{ background: holdingColor(h, i) }} />
            <span className="legend__label">{h.ticker || h.label || 'Unnamed'}</span>
            <b className="tnum">{formatPct(h.pct)}</b>
          </li>
        ) : null
      )}
    </ul>
  );
}
